import axiosInstance from '../../../configs/axios';

// Admin authentication API
export const adminAuthAPI = {
  login: async (data: { email: string; password: string }) => {
    const response = await axiosInstance.post('/admin/login', data);
    return response.data;
  },
};
